import React, { FC } from 'react'
import Head from 'next/head'
import { Region } from '@moonpig/web-core-types'
import { BRAND_LABEL } from '@moonpig/web-core-brand/config'
import { useFindLocaleText } from '../../text-localisation'

type SearchHeadProps = {
  region: Region
  page: number
}

export const SearchHead: FC<SearchHeadProps> = ({ region, page }) => {
  const localiseText = useFindLocaleText()
  const canonicalUrl = `${process.env.HOST_URL}/${region}/search/`

  const dynamicTitle =
    page > 1
      ? `${localiseText('find.search_results')} - ${localiseText(
          'find.page',
        )} ${page} | ${BRAND_LABEL}`
      : `${localiseText('find.search_results')} | ${BRAND_LABEL}`

  return (
    <Head>
      <title>{dynamicTitle}</title>
      <link
        rel="canonical"
        data-testid="content-head-canonical"
        href={canonicalUrl}
      />
      <meta name="title" content={dynamicTitle} />
      <meta name="description" content="Search Results" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content="Search Results" />
      <meta property="og:description" content="Search Results" />
      <meta property="og:locale" content="en-GB" />
      <meta property="og:type" content="website" />
      <meta data-testid="robots" name="robots" content="noindex, nofollow" />
    </Head>
  )
}
